module.exports = __webpack_public_path__ + "img/half.10b9352.png";